import {
  Booking,
  InvestmentQuoteNotationEnum,
  InvestmentTypeEnum,
} from "@rentablo/api/apiv1";
import { TableBookingData } from "./BookingsSingleInvestmentTable";

export const toTableBookingData = (
  bookings: Booking[],
  investmentQuote: number,
  quoteNotation?: InvestmentQuoteNotationEnum
): TableBookingData[] =>
  bookings.map((booking): TableBookingData => {
    const entryQuote = booking?.entryQuote
      ? Math.abs(booking.entryQuote)
      : null;
    const priceChange =
      booking.type === "dividend" || !entryQuote || entryQuote === 0
        ? null
        : investmentQuote / entryQuote - 1;
    const expenses = (booking.commission ?? 0) + (booking.taxAmount ?? 0);
    const grossGain =
      booking.type === "sell"
        ? (booking.realizedGain?.grossGain ?? null)
        : null;

    return {
      id: booking.id,
      valueDate: booking.valueDate,
      bookingType: booking.type,
      numberOfLots: booking.numberOfLots,
      securityPrice: Math.abs(booking.securityPrice),
      priceChange,
      expenses,
      amount: booking.amount,
      grossGain,
      isExternalID: Boolean(booking.externalId),
      comment: booking.comment,
      currency: booking.currency,
      investmentId: booking.investment.id,
      investmentType: booking.investment.type as InvestmentTypeEnum,
      quoteNotation,
      dataConsistencyStatus: booking.dataConsistencyStatus,
      isCancelled: booking.cancellationId !== undefined,
    };
  });
